import IBaixarComprovanteExtratoRequest from '../entities/IBaixarComprovanteExtratoRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IBaixarComprovante {
  execute(params: IBaixarComprovanteExtratoRequest): Promise<any>
}

export default class BaixarComprovanteImpl implements IBaixarComprovante {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(params: IBaixarComprovanteExtratoRequest): Promise<any> {
    return this.pagamentosRepository.baixarComprovante(params)
  }
}
